var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudgetSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    d: "M11 2.049V4.06a8.001 8.001 0 1 0 5.905 14.258l1.424 1.423A9.958 9.958 0 0 1 12 22C6.477 22 2 17.522 2 12c0-5.185 3.947-9.448 9-9.95Zm10.95 10.95a9.954 9.954 0 0 1-2.207 5.329l-1.423-1.423a7.96 7.96 0 0 0 1.618-3.906h2.013ZM13.002 2.05c4.724.47 8.48 4.226 8.95 8.95h-2.013a8.004 8.004 0 0 0-6.937-6.938V2.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetSplit);
export default __webpack_public_path__ + "static/media/budget-split.62013ba9c7abacc3f4a7b3174438d468.svg";
export { ForwardRef as ReactComponent };